import {dataLinksApi, messagesService} from "@dv5/api"
import {pocketService} from "@dv5/pocket"

interface CreateDataLinkData {
    canvasId: string
    widgetId: string
    linkType: string
    externalLinkId: string | null
    externalLinkUrl: string | null
    linkTitle: string
}

class DataLinkService {
    createLink(widgetsToProcess: Array<string>, canvasId: string) {
        const widgetId = widgetsToProcess[0]
        const pocketItem = pocketService.getSelectedItem()
        if (pocketItem) {
            const linkType = dataLinksApi.getLinkType(pocketItem)
            const externalUrl = dataLinksApi.getLinkUrl(pocketItem)
            if (!linkType) {
                console.error('Unknown link type')
                return
            }
            messagesService.send<CreateDataLinkData>('canvas.create-data-link', {
                canvasId: canvasId,
                widgetId: widgetId,
                linkType: linkType,
                externalLinkId: null,
                externalLinkUrl: externalUrl,
                linkTitle: pocketItem.title
            })
        }
    }
}

export const dataLinkService = new DataLinkService()